module.exports = __webpack_public_path__ + "img/vender-carro.019c4bad.svg";